import React from 'react';

import BreakdownTable from '../shared/BreakdownTable';
import useStreamingBreakdownData from './utils/useStreamingBreakdownData';
import { IBreakdownTableProps } from './BreakdownTable';

const SourcesBreakdownTable: React.FC<IBreakdownTableProps> = (props) => {
  const { breakdownData, isPending, activeMetric } = props;

  const breakdowns = useStreamingBreakdownData(
    breakdownData,
    activeMetric.value
  );

  return (
    <>
      {breakdowns && (
        <BreakdownTable
          headers={['Source', activeMetric.label]}
          breakdowns={breakdowns}
          isPending={isPending}
          activeMetric={activeMetric}
        />
      )}
    </>
  );
};

export default SourcesBreakdownTable;
